import React, { CSSProperties } from "react";
import { eComicSeriesAlpha0 } from "../model/DataConst";
import { MAIN_URL } from "../model/Const";

const BackToMain = ( props: { style: CSSProperties } ) => {
	return <section style={{
		...props.style,
		height: "6vmin",
		width: "100%",
		top: 0,
		left: 0,
		backgroundColor: "#df003a",
	}}>
		<a href={MAIN_URL} target="_blank" rel="noopener noreferrer" style={{
			cursor: "pointer",
			textDecoration: "none",
		}}>
				<span style={{
					color: "white",
					fontSize: "4vmin",
					fontWeight: "bold",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100%"
				}}>
				<img
					style={{
						height: "4vmin",
						marginRight: "4vmin"
					}}
					src={eComicSeriesAlpha0}
					alt={"eComicシリーズ"}/>
					TOPへ
				</span>
		</a>
	</section>;
};

export default BackToMain;